import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import PartnerMap from "../components/Partners/PartnerMap";

import partners from "../content/partners.json";

const Partners = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 7, md: 10 },
          background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
          color: theme.palette.common.white,
          textAlign: "center",
        }}
      >
        <Chip
          label="Hospitals and partners"
          sx={{
            bgcolor: "rgba(255,255,255,0.1)",
            color: theme.palette.common.white,
            border: "1px solid rgba(255,255,255,0.2)",
            mb: 2,
            fontWeight: 800,
          }}
        />
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: { xs: "2.5rem", md: "4rem" },
          }}
        >
          Our Partners
        </Typography>
        <Typography
          sx={{
            maxWidth: 760,
            mx: "auto",
            mt: 2,
            color: "rgba(255,255,255,0.84)",
            lineHeight: 1.8,
            fontSize: { xs: "1rem", md: "1.08rem" },
          }}
        >
          A focused map of our hospital partnerships. Click on a pin to learn more about the partnership.
        </Typography>
      </Box>

      <Box sx={{ px: 0, py: 0 }}>
        <PartnerMap partners={partners} />
      </Box>
    </Box>
  );
};

export default Partners;
